import { MomentUtcDateAdapter } from '@adapter/moment-utc-adapter';
import { provideMaterialTheme } from '@akelius/material-theme';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideServiceWorker, SwRegistrationOptions } from '@angular/service-worker';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { apiUrlInterceptor } from '@interceptors/api-url.interceptor';
import { serverErrorInterceptor } from '@interceptors/server-error.interceptor';
import { AppMissingTranslationHandler } from '@modules/sentry/missing-translation.interceptor';
import { sentryErrorInterceptor } from '@modules/sentry/sentry.interceptor';
import { provideSentry } from '@modules/sentry/sentry.providers';
import { MissingTranslationHandler, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { EnvironmentService } from '@services/environment.service';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { routeConfig, routingConfiguration } from './route.config';

export function provideMomentUtcDateAdapter() {
    return [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        { provide: DateAdapter, useClass: MomentUtcDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ];
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routeConfig, withRouterConfig(routingConfiguration)),
        provideHttpClient(
            withInterceptors([
                apiUrlInterceptor,
                serverErrorInterceptor,
                sentryErrorInterceptor,
                authHttpInterceptorFn,
            ]),
        ),
        provideTranslateService({
            loader: provideTranslateHttpLoader(),
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: AppMissingTranslationHandler,
            },
        }),
        provideAuth0(environment.auth),
        importProvidersFrom(
            NgxGoogleAnalyticsModule.forRoot(environment.googleAnaliticsKey), // TODO: this needs to be repleaced with new syntax
        ),
        { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { position: 'above' } },
        {
            provide: SwRegistrationOptions,
            useFactory: (environmentService: EnvironmentService) => ({
                enabled: environmentService.getEnvinronment().isServiceWorkerEnabled,
            }),
            deps: [EnvironmentService],
        },
        { provide: Window, useValue: window },
        provideMomentUtcDateAdapter(),
        provideMaterialTheme(),
        provideAnimations(),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.isServiceWorkerEnabled,
        }),
        provideSentry(environment.sentryConfiguration),
    ],
};
